import { Globals } from '@/modules/Globals';
import { vueData } from '@/VueData';
import { defineStore } from 'pinia';
import { reactive, toRefs, markRaw, toRef } from 'vue';
import io from 'socket.io-client';

export const useSocketStore = defineStore('socket', () => {
  const state = reactive({
    socket: null as SocketIOClient.Socket | null,
    isConnected: false,
  });

  const actions = {
    setSocket(socket: SocketIOClient.Socket) {
      state.socket = markRaw(socket);

      state.isConnected = socket.connected;

      socket.on('connect', () => {
        console.log('[RealTime] Connected');
        state.isConnected = true;
      });

      socket.on('disconnect', () => {
        console.log('[RealTime] Disconnected');
        state.isConnected = false;
      });
    },
    connect() {
      state.socket?.connect();
    },
    disconnect() {
      state.socket?.disconnect();
    },
  };

  return {
    ...toRefs(state),
    ...actions,
  };
});

export function useSocket(main = false, socket?: SocketIOClient.Socket) {
  const store = useSocketStore();

  if (main) {
    if (!socket) {
      throw new Error('Socket is required for main useSocket');
    }
    store.setSocket(socket);
    store.socket.on('version', (version) => {
      setTimeout(() => {
        vueData.latestVersion = version;
      }, 5000);
    });
  }

  return markRaw({
    socket: toRef(store, 'socket'),
    isConnected: toRef(store, 'isConnected'),
    connect: store.connect,
    disconnect: store.disconnect,
  });
}
